import React from 'react';
import {StackDirection, StackSpacing} from './stack.types';

interface StackProps {
  children: React.ReactNode;
  className?: string;
  direction?: StackDirection;
  spacing?: StackSpacing;
}

const directionClasses: Record<StackDirection, string> = {
  [StackDirection.Horizontal]: 'flex flex-row',
  [StackDirection.Vertical]: 'flex flex-col',
};

const spacingClasses: Record<StackSpacing, string> = {
  [StackSpacing.SM]: 'gap-2',
  [StackSpacing.MD]: 'gap-4',
};

export const Stack: React.FC<StackProps> = ({children, className = '', direction = StackDirection.Vertical, spacing = StackSpacing.MD}) => (
  <div className={`${directionClasses[direction]} ${spacingClasses[spacing]} ${className}`.trim()}>{children}</div>
);
